/* tslint:disable */
/* eslint-disable */
export enum InvoiceGenerationCriteria {
  RegistrationCode = 'REGISTRATION_CODE',
  Client = 'CLIENT',
}
